/* eslint-disable import/extensions */
import { Section } from 'classes/faq/Section.class';
import { createAction, createAsyncAction } from 'typesafe-actions';

export const loadFAQAsync = createAsyncAction(
  'LOAD_FAQ_REQUEST',
  'LOAD_FAQ_SUCCESS',
  'LOAD_FAQ_FAILURE',
)<void, Section[], string>();
